enum Plane {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export default Plane;
